import {
  Agreement,
  AgreementSwitcher,
  AgreementWaitingForContract,
  IHistoryData,
  TotalDebtAmountOnAllAgreementsByCurrency
} from '../agreements/agreements.model';
import { ContractAgreementsState } from './contractAgreements';

const reducers = {
  storeAllAgreements: (
    state: ContractAgreementsState,
    agreements: Agreement[],
    totalDebtAmountOnAllAgreementsByCurrency: TotalDebtAmountOnAllAgreementsByCurrency
  ) => ({
    ...state,
    totalDebtAmountOnAllAgreementsByCurrency,
    agreements
  }),
  storeAgreementDetails: (
    state: ContractAgreementsState,
    agreement: Agreement,
    agreementId: number
  ) => {
    const prev = state[agreementId];
    const prevPayments = prev?.details?.payments ?? [];
    return {
      ...state,
      [agreementId]: {
        ...agreement,
        details: {
          ...agreement.details,
          // as contract details does not return this data, to avoid override
          payments: prevPayments
        }
      }
    };
  },
  storeAgreementPayments: (
    state: ContractAgreementsState,
    payments: IHistoryData[],
    agreementId: number
  ) => ({
    ...state,
    [agreementId]: {
      ...state[agreementId],
      details: {
        ...state[agreementId]?.details,
        payments
      }
    }
  }),

  storeAgreementsWaitingForContract: (
    state: ContractAgreementsState,
    data: AgreementWaitingForContract[]
  ) => ({ ...state, agreementsWaitingForContract: data }),
  storeAgreementsWithProductAvailability: (
    state: ContractAgreementsState,
    agreements: AgreementSwitcher[]
  ) => ({ ...state, agreementsWithProductAvailability: agreements })
};

export default reducers;
